import { render, staticRenderFns } from "./postsSideBar.vue?vue&type=template&id=47be262a&scoped=true&"
import script from "./postsSideBar.vue?vue&type=script&lang=js&"
export * from "./postsSideBar.vue?vue&type=script&lang=js&"
import style0 from "./postsSideBar.vue?vue&type=style&index=0&id=47be262a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be262a",
  null
  
)

export default component.exports